<template>
  <SliderSelector :mandatory="isMandatory" :value="value" v-bind="$attrs" @input="onInput" />
</template>

<script>
import SliderSelector from "./SliderSelector";
export default {
  components: {
    SliderSelector,
  },

  props: {
    value: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      localValue: this.value,
      isMandatory: false,
    };
  },

  created() {
    this.setIsMandatory();
  },

  methods: {
    onInput(value) {
      this.$emit("input", value);
      this.localValue = value;
      this.setIsMandatory();
    },
    setIsMandatory() {
      if (!this.localValue) return;
      this.isMandatory = true;
    },
  },
};
</script>
